import { Matrix, Quaternion, Vector3 } from '@babylonjs/core/Maths/math.vector';
import { WebXRSessionManager } from '@babylonjs/core/XR/webXRSessionManager';

export interface IXrHitResult {
    position: Vector3;
    rotation: Quaternion;
    matrix: Matrix;
    xrResult: XRHitTestResult;
}

export class XrHitTester {
    constructor(public sessionMgr: WebXRSessionManager) {}

    /** holds the hit test source which is filled after initialize() has been called */
    public source: XRHitTestSource | undefined;
    /** temp variables for saving memory while processing hit results */
    private _tmpPos = new Vector3();
    private _tmpMat = new Matrix();
    private _tmpQuat = new Quaternion();

    public initialize(offsetRay?: XRRay) {
        const session = this.sessionMgr.session;

        //setup initial hit testing source
        if (session) {
            return session.requestHitTestSource!({
                space: this.sessionMgr.viewerReferenceSpace, //we use the viewer ref space for the source
                offsetRay: offsetRay,
            }).then(hitSource => {
                return (this.source = hitSource);
            });
        }
    }

    public getHitResult(frame: XRFrame): IXrHitResult | undefined {
        if (!this.source) return;

        const hits = frame.getHitTestResults(this.source);
        if (!hits.length) return;

        const hit = hits[0]; //only concentrate on the first hit... might want to reconsider this later
        return XrHitTester.FromXRHitTestResult(hit, this.sessionMgr.referenceSpace);

        // // Check that the y-coordinate of the normal is large enough that the normal
        // // is pointing up.
        // return hitMatrix hitMatrix.elements[5] > 0.75 ?
        //     hitPosition.setFromMatrixPosition(hitMatrix) :
        //     null;
    }

    public static FromXRHitTestResult(hit: XRHitTestResult, refSpace: XRSpace) {
        const pose = hit.getPose(refSpace);
        if (pose == null) return;

        const xrpos = pose.transform.position;
        const xrquat = pose.transform.orientation;
        const mat = new Matrix();
        Matrix.FromFloat32ArrayToRefScaled(pose.transform.matrix, 0, 1, mat);

        return {
            position: new Vector3(xrpos.x, xrpos.y, xrpos.z),
            rotation: new Quaternion(xrquat.x, xrquat.y, xrquat.z, xrquat.w),
            matrix: mat,
            xrResult: hit,
        } as IXrHitResult;
    }

    public dispose() {
        if (this.source) {
            this.source.cancel();
            this.source = undefined;
        }
    }
}
